import React from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarCategoriaCpbsDs } from "../DataSources";
import UserInfo from "../UserInfo";




export default class CategoriaCpbsBox extends React.Component {
    constructor(){
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Categoria de CPBS">
                    <DataGrid
                        dataSource={criarCategoriaCpbsDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'id'} width={'150'} allowEditing={false} visible={false}/>
                        <Column dataField={'sequencial'} caption={"#"} width={'150'} allowEditing={false}/>
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}